<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Obligations légales" subTitle="" srcImg="/images/pages/conseil-rh/desc-picture.png"
        backgroundSpan="span-background-blue" />
    </section>
    <section>
      <NavLeft tab="obligations_legales" breadcrumb1="" breadcrumb2="Obligations légales" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - Conseils RH pour les obligations sociales et légales",
  meta: [
    {
      name: "description",
      content: "Dans le cadre de nos missions de conseil RH, nous accompagnons les dirigeants dans la mise en place des obligations légales et sociales."
    }
  ]
})
</script>

<style scoped>
.body {
  
  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>